/**
 * The angularjs states related to the module MetricsModule
 */
metricsStates.$inject = ['$stateProvider'];
export function metricsStates($stateProvider) {
  addAnalyticsStates($stateProvider, 'care');
  addAnalyticsStates($stateProvider, 'marketing');
}

function addAnalyticsStates($stateProvider, navigationMode) {
  const metricsReportState =
    navigationMode === 'care'
      ? 'auth.alcmeon.fuse.metrics-and-reports'
      : 'auth.alcmeon.fuse.marketing-metrics-and-reports';
  $stateProvider
    .state(metricsReportState, {
      abstract: true,
      url: navigationMode === 'care' ? '/metrics-and-reports' : '/marketing-metrics-and-reports',
      resolve: {
        scenarios: [
          'AngularMetricsService',
          function (AngularMetricsService) {
            return AngularMetricsService.getScenariosSimplifiedInfo('all-flavors').toPromise();
          },
        ],
        crmOrganizations: [
          'AngularCrmOrganizationsService',
          function (AngularCrmOrganizationsService) {
            return AngularCrmOrganizationsService.getOrganizationsList().toPromise();
          },
        ],
        roles: [
          'AngularUsersService',
          function (AngularUsersService) {
            return AngularUsersService.getRoleNames().toPromise();
          },
        ],
        customEvents: [
          'AngularCustomEventsService',
          function (AngularCustomEventsService) {
            return AngularCustomEventsService.findAll()
              .toPromise()
              .then(response => response.scenarioCustomEvents);
          },
        ],
        navigationMode: () => navigationMode,
        metrics: [
          'AngularMetricsService',
          function (AngularMetricsService) {
            return AngularMetricsService.getMetrics(navigationMode).toPromise();
          },
        ],
      },
    })
    .state(metricsReportState + '.metric-reports', {
      url: '/metric-reports',
      views: {
        'container@auth': {
          controller: [
            '$state',
            function ($state) {
              $state.go(metricsReportState + '.metric-reports.overview');
            },
          ],
        },
        'sub-nav@auth': {
          template: '', // a rule in core.scss makes an empty sub-nav disappear altogether
        },
      },
    })

    // routes AJS for each NG tabs
    .state(metricsReportState + '.metric-reports.overview', {
      url: '/overview',
      views: {
        'container@auth': {
          controller: DashboardController,
          template:
            '<angular-dashboard [selected-tab]="0" [scenarios]="scenarios" [roles]="roles" [custom-events]="customEvents"></angular-dashboard>',
        },
        'sub-nav@auth': {
          template: '', // a rule in core.scss makes an empty sub-nav disappear altogether
        },
      },
    })

    .state(metricsReportState + '.metric-reports.logged-users', {
      url: '/logged-users',
      views: {
        'container@auth': {
          controller: DashboardController,
          template:
            '<angular-dashboard [selected-tab]="1" [scenarios]="scenarios" [roles]="roles" [custom-events]="customEvents"></angular-dashboard>',
        },
        'sub-nav@auth': {
          template: '', // a rule in core.scss makes an empty sub-nav disappear altogether
        },
      },
    })

    .state(metricsReportState + '.metric-reports.reports', {
      url: '/reports',
      views: {
        'container@auth': {
          controller: DashboardController,
          template:
            '<angular-dashboard [selected-tab]="2" [scenarios]="scenarios" [roles]="roles" [custom-events]="customEvents"></angular-dashboard>',
        },
        'sub-nav@auth': {
          template: '', // a rule in core.scss makes an empty sub-nav disappear altogether
        },
      },
    })

    .state(metricsReportState + '.metrics', {
      url: '/metrics/:metricId?fromReportId',
      resolve: {
        routingTagsUsesAi: [
          'AngularMetricsService',
          function (AngularMetricsService) {
            return AngularMetricsService.getRoutingTagsUsesAi().toPromise();
          },
        ],
        metric: [
          '$stateParams',
          'AngularMetricsService',
          function ($stateParams, AngularMetricsService) {
            return AngularMetricsService.getMetric($stateParams.metricId)
              .toPromise()
              .then(response => response);
          },
        ],
      },
      views: {
        'sub-nav@auth': {
          template: require('src/ajs-app/components/core/subnav/navigation.metrics.html'),
          controller: 'NavigationMetricsController',
        },
        'container@auth': {
          template: require('src/ajs-app/components/metrics/metric-material.html'),
          controller: 'MetricController',
        },
      },
    })

    .state(metricsReportState + '.metrics-category', {
      url: '/metrics-category?{category:any}', // :any to work around slash double-url-encoding, see https://github.com/angular-ui/ui-router/issues/1645#issuecomment-85637641
      resolve: {
        metrics: [
          'AngularMetricsService',
          function (AngularMetricsService) {
            return AngularMetricsService.getMetrics(navigationMode)
              .toPromise()
              .then(response => response);
          },
        ],
      },
      views: {
        'sub-nav@auth': {
          resolve: {
            navigationMode: () => navigationMode,
          },
          template: require('src/ajs-app/components/core/subnav/navigation.metrics.html'),
          controller: 'NavigationMetricsController', // the controller will redirect to a best effort metric
        },
      },
    });
}

DashboardController.$inject = ['$scope', 'scenarios', 'roles', 'customEvents', 'navigationMode'];
export function DashboardController($scope, scenarios, roles, customEvents, navigationMode) {
  $scope.scenarios = scenarios;
  $scope.roles = roles;
  $scope.customEvents = customEvents;
  $scope.navigationMode = navigationMode;
}
